<button (click)="handleClick()" class="btn btn-dark d-flex gap-1 rounded-pill" type="button">
  <span class="material-symbols-outlined">
  person
  </span>
  <span>{{client.name}}</span>
  <span>-</span>
  <span>{{client.idnumber}}</span>
  <span class="material-symbols-outlined">
  close
  </span>
</button>
